'use strict';

namespace Core {

    class AbTestSelector {

        tests: string;
        bindableTests: any[];

        constructor( private cookieService : any ) {
            this.bindableTests = JSON.parse(this.tests);
            this.bindableTests.forEach(t => {
                const cookie = cookieService.get(t.CookieName);
                t.variant = cookie ? parseInt(cookie, 10) : 0;
            });
        }

        update() {
            this.bindableTests.forEach(t => {
                this.cookieService.set(t.CookieName, t.variant, t.variant === 0 ? new Date() : null);
            });
        }

        numArray(i) {
            return new Array(i);
        }
    }

    angular
        .module('core')
        .directive('abTestSelector', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: true,
                scope: {},
                bindToController: {
                    tests: '@'
                },
                controller: AbTestSelector,
                controllerAs: 'abt',
                templateUrl: 'partials/home/directivetemplate?type=AbTestSelector'
            };
        });
}

